import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

export default function BusinessVideos() {
  const { businessId } = useParams();
  const [videos, setVideos] = useState([]);
  const [filteredVideos, setFilteredVideos] = useState([]);
  const [business, setBusiness] = useState(null);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState('');
  const [clipModal, setClipModal] = useState({
    show: false,
    url: '',
    start: '',
    end: '',
    loading: false
  });

  useEffect(() => {
    const fetchVideos = async () => {
      try {
        const businessRes = await axios.get(`${API_URL}/api/business/${businessId}`);
        const biz = businessRes.data;
        setBusiness(biz);

        const videoRes = await axios.get(`${API_URL}/api/videos/${businessId}`);
        // 🟩 Videoları en yeniye göre sırala (lastModified azalan)
        const sorted = videoRes.data.sort(
          (a, b) => new Date(b.lastModified) - new Date(a.lastModified)
        );

        setVideos(sorted);
        setFilteredVideos(sorted);
      } catch (err) {
        console.error('Videolar alınamadı:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchVideos();
  }, [businessId]);

  useEffect(() => {
    const normalize = (str) =>
      str
        .toLocaleLowerCase('tr')
        .replace(/ı/g, 'i')
        .replace(/İ/g, 'i')
        .replace(/ü/g, 'u')
        .replace(/Ü/g, 'u')
        .replace(/ö/g, 'o')
        .replace(/Ö/g, 'o')
        .replace(/ç/g, 'c')
        .replace(/Ç/g, 'c')
        .replace(/ş/g, 's')
        .replace(/Ş/g, 's')
        .replace(/ğ/g, 'g')
        .replace(/Ğ/g, 'g');

    const filtered = videos.filter((v) =>
      normalize(v.name).includes(normalize(searchQuery))
    );
    setFilteredVideos(filtered);
  }, [searchQuery, videos]);

  const openClipModal = (url) =>
    setClipModal({ show: true, url, start: '', end: '', loading: false });
  const closeClipModal = () =>
    setClipModal({ show: false, url: '', start: '', end: '', loading: false });

  const handleClipDownload = async () => {
    if (clipModal.start === '' || clipModal.end === '')
      return alert('Başlangıç ve bitiş zamanlarını girin!');
    setClipModal((prev) => ({ ...prev, loading: true }));

    try {
      const res = await axios.post(
        `${API_URL}/api/videos/clip`,
        { videoUrl: clipModal.url, start: clipModal.start, end: clipModal.end },
        {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
          responseType: 'blob'
        }
      );

      const blob = new Blob([res.data], { type: 'video/mp4' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'clip.mp4';
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      alert('Klip oluşturulamadı!');
      console.error(err);
    }

    closeClipModal();
  };

  if (loading) return <p className="text-center my-5">Videolar yükleniyor...</p>;

  return (
    <div className="container my-5">
      <h2 className="text-center text-success mb-4">
        {business ? business.businessName : 'İşletme'} – Maç Videoları
      </h2>

      <div className="mb-4">
        <input
          type="text"
          className="form-control rounded-pill"
          placeholder="Video adına göre ara..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </div>

      {filteredVideos.length === 0 ? (
        <p className="text-center text-muted">Bu işletmeye ait video bulunamadı.</p>
      ) : (
        <div className="row">
          {filteredVideos.map((v, i) => (
            <div key={i} className="col-md-6 col-lg-4 mb-3">
              <div className="card shadow-sm border-success">
                <video controls style={{ width: '100%', borderRadius: '8px' }}>
                  <source src={v.url} type="video/mp4" />
                </video>
                <div className="card-body text-center">
                  <p className="text-muted small mb-1">{v.name.split('/').pop()}</p>
                  <p className="text-secondary small mb-2">
                    {new Date(v.lastModified).toLocaleDateString('tr-TR', {
                      day: '2-digit',
                      month: 'long',
                      year: 'numeric'
                    })}{' '}
                    -{' '}
                    {new Date(v.lastModified).toLocaleTimeString('tr-TR', {
                      hour: '2-digit',
                      minute: '2-digit'
                    })}
                  </p>
                  {localStorage.getItem('token') ? (
                    <button
                      className="btn btn-outline-success btn-sm"
                      onClick={() => openClipModal(v.url)}
                    >
                      🎬 Klip Al
                    </button>
                  ) : (
                    <p className="text-muted small">Klip almak için giriş yapın</p>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* 🎬 Klip alma modalı */}
      {clipModal.show && (
        <div
          className="modal show d-block bg-dark bg-opacity-75"
          onClick={closeClipModal}
        >
          <div
            className="modal-dialog modal-dialog-centered"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">🎬 Klip Al</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={closeClipModal}
                ></button>
              </div>
              <div className="modal-body">
                <label className="form-label">
                  Başlangıç (saat:dakika:saniye)
                </label>
                <input
                  type="text"
                  className="form-control mb-2"
                  placeholder="örnek: 0:57:53"
                  value={clipModal.start}
                  onChange={(e) =>
                    setClipModal({ ...clipModal, start: e.target.value })
                  }
                />
                <label className="form-label">
                  Bitiş (saat:dakika:saniye)
                </label>
                <input
                  type="text"
                  className="form-control mb-3"
                  placeholder="örnek: 1:01:23"
                  value={clipModal.end}
                  onChange={(e) =>
                    setClipModal({ ...clipModal, end: e.target.value })
                  }
                />
                <button
                  className="btn btn-success w-100"
                  disabled={clipModal.loading}
                  onClick={handleClipDownload}
                >
                  {clipModal.loading ? 'İşleniyor...' : 'Klip Oluştur ve İndir'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
